import {FC} from 'react'
import {useTranslation} from '@/translations/i18n.tsx'
import {errorHandler} from '@utilities/helpers.ts'
import {useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {DeleteModal} from '@/components/commons/delete-modal/DeleteModal'
import {useDeleteMedicalReport} from '@/features/medical-reports/queries/useDeleteMedicalReport'
import {MedicalRecord} from '@/features/medical-records/types'
import {medicalReportKeyMapToLabel} from '@/features/medical-reports/utils'

interface DeleteMedicalReportModalProps {
    onClose: () => void
    onSuccess?: () => void
    medicalReport: MedicalRecord['reports'][number]
}
export const DeleteMedicalReportModal: FC<DeleteMedicalReportModalProps> = ({medicalReport, onClose, onSuccess}) => {
    const {t} = useTranslation()
    const queryClient = useQueryClient()
    const deleteMutation = useDeleteMedicalReport(medicalReport.id, {
        onError: errorHandler,
        onSuccess: async () => {
            await queryClient.cancelQueries({queryKey: [QUERY_KEYS.PATIENT_MEDICAL_RECORD]})
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PATIENT_MEDICAL_RECORD]})
            onSuccess?.()
            onClose()
        }
    })

    return (
        <DeleteModal
            onClose={onClose}
            deleteMutation={deleteMutation}
            canBeDeleted={true}
            fullName={t(medicalReportKeyMapToLabel[medicalReport.medicalRecordReportType.keyName])}
            paragraph1={t('commons:delete_paragraph_1')}
            title={t('patients:delete_report_title')}
            deniedTitle=""
            deniedParagraph=""
        />
    )
}
